import React from 'react'
import { cn } from '../utils'

export const MoneyDisplay: React.FC<{
    amount: number;
    currency: string;
    className?: string;
    size?: 'sm' | 'md' | 'lg';
    showSign?: boolean;
}> = ({ amount, currency, className, size = 'md', showSign = false }) => {
    const sizes = {
        sm: 'text-[13px]',
        md: 'text-[15px]',
        lg: 'text-[22px] tracking-[-0.5px]',
    }
    
    const symbols: Record<string, string> = {
        RUB: '₽',
        USD: '$',
        EUR: '€',
        GBP: '£',
        CNY: '¥',
    }
    
    const symbol = symbols[currency] || currency
    
    const formatted = new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(Math.abs(amount))

    const sign = showSign && amount > 0 ? '+' : amount < 0 ? '−' : ''

    return (
        <span className={cn('font-mono font-[500] tabular-nums', sizes[size], className)}>
            {sign}{formatted} <span className="text-gray-400 dark:text-gray-500 font-[400] text-[0.85em]">{symbol}</span>
        </span>
    )
}